import { render, staticRenderFns } from "./welfareRules.vue?vue&type=template&id=798ce77f&scoped=true&"
import script from "./welfareRules.ts?vue&type=script&lang=js&"
export * from "./welfareRules.ts?vue&type=script&lang=js&"
import style0 from "./welfareRules.less?vue&type=style&index=0&id=798ce77f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ce77f",
  null
  
)

export default component.exports